import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MobiOfficeUIState } from "./mobi-office-ui.interface";

const mobiOfficeUISelector = createFeatureSelector<MobiOfficeUIState>("MOBIOFFICE_UI");

export const select_MOUI_User = createSelector(mobiOfficeUISelector, (state: MobiOfficeUIState) => state?.USER_MASTER);
export const select_MOUI_DynamicTableColumn = createSelector(mobiOfficeUISelector, (state: MobiOfficeUIState) => state?.DYNAMIC_TABLE_COLUMN);
export const select_MOUI_ApplicationDetails = createSelector(mobiOfficeUISelector, (state: MobiOfficeUIState) => state?.APPLICATION_DETAILS);
export const select_MOUI_UserApplications = createSelector(mobiOfficeUISelector, (state: MobiOfficeUIState) => state?.USER_APPLICATIONS);
